import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

import { loginPathFor } from "../../lib/nextPath";

// eslint-disable-next-line react/prop-types
const ProtectedRoute = ({ children }) => {
  const { token, isHydrated } = useSelector((state) => state.auth);
  const location = useLocation();
  // Hold rendering until redux-persist has rehydrated the auth slice from
  // localStorage. Without this guard, a full-page load at a protected URL
  // (e.g. a push-notification deep-link) would briefly see token=null and
  // redirect to "/" before REHYDRATE fires — appearing as a logout to the user.
  if (!isHydrated) return null;
  // Carry the destination through the login screen. Without it, someone who
  // taps "Open" on a notification while their session is gone logs in and
  // lands on /home — the event or section they were clicking through to is
  // dropped. Thread #1727 (Event Chat "Open" logged the recipient out).
  return token ? children : <Navigate to={loginPathFor(location)} replace />;
};

export default ProtectedRoute;
